export const hy = {
  title: 'Քամու արագության պոտենցիալ',
  subtitle: '1 կմ, գլոբալ, DTU/World Bank Group/ESMAP',
  download_data: '',
  learn_more: '',
  content: [
    {
      label: 'Գործառույթ',
      value: 'Նշանակում է քամու արագություն Երկրի ցանկացած տեղանքի համար',
    },
    {
      label: 'Բանաձեւ',
      value: '1 կմ',
    },
    {
      label: 'Աշխարհագրական ծածկույթ',
      value: 'Գլոբալ',
    },
    {
      label: 'Աղբյուր',
      value: '\tDTU/Համաշխարհային բանկի խումբ/ESMAP',
    },
    {
      label: 'Հաճախականություն',
      value: '',
    },
    {
      label: 'Բովանդակության ամսաթիվը',
      value: '',
    },
    {
      label: 'Զգուշացումներ',
      value:
        'ԳՎԱ-ն օգտագործում է երկու հիմնական մոդելավորման բաղադրիչներ, որոնք կարող են անորոշություն մտցնել հաշվարկների մեջ։ Այս բաղադրիչներն են մեզոսկոպիկ մոդելավորումն ու միկրոսկալ մոդելավորում:',
    },
    {
      label: 'Լիցենզիա',
      value: '[CC 4.0](https://creativecommons.org/licenses/by/4.0/)',
    },
  ],
  overview: {
    label: 'Ընդհանուր ակնարկ',
    value:
      'Գլոբալ քամու ատլասը (GWA) նշանակում է քամու արագության տվյալների բազան ստեղծվել է Դանիայի տեխնիկական համալսարանի (DTU), Համաշխարհային բանկի խմբի եւ էներգետիկայի ոլորտի կառավարման օժանդակության ծրագրի (ESMAP) կողմից:\n\nՔամու միջին արագությունը քամու էներգիայի արտադրության հիմնական ցուցանիշներից մեկն է։ GWA-ն սկսվում է քամու արագության ցածր լուծաչափ ունեցող տվյալներից եւ փոխակերպում է այն բարձր լուծաչափ ունեցող տվյալների՝ օգտագործելով նվազման գործընթաց: Այս պրոցեսի արդյունքը երկրագնդի վրա տեղական քամու կլիմայի մոդելն է (բացառությամբ Հյուսիսային եւ Հարավային բեւեռների եւ հեռավոր ծովամերձ օվկիանոսային տարածքների) 1 կիլոմետր բանաձեւով երեք բարձրությունների համար՝ 50 մետր, 100 մետր եւ 200 մետր:',
  },
  citation: {
    label: 'Մեջբերում',
    value:
      'Data/information/map obtained from the Global Wind Atlas 2.0, a free, web-based application developed, owned and operated by the Technical University of Denmark (DTU) in partnership with the World Bank Group, utilizing data provided by Vortex, with funding provided by the Energy Sector Management Assistance Program (ESMAP). For additional information: https://globalwindatlas.info. Accessed through Resource Watch, (date)',
  },
};
